export default "__VITE_ASSET__DjOthlxl__"